import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-16 mb-20">
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-white/50 mb-5">
              Product Categories
            </h4>
            <div className="w-8 h-px bg-white/20 mb-5"></div>
            <ul className="space-y-3">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Shoes</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Hoodies / Sweaters</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">T-Shirts</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Jackets</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-white/50 mb-5">
              Shopping Guides
            </h4>
            <div className="w-8 h-px bg-white/20 mb-5"></div>
            <ul className="space-y-3">
              <li>
                <Link to="/article/superbuy-spreadsheet-complete-guide" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Complete Guide</Link>
              </li>
              <li>
                <Link to="/article/superbuy-spreadsheet-qc-guide" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">QC Guide</Link>
              </li>
              <li>
                <Link to="/article/superbuy-spreadsheet-shipping-guide" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Shipping Guide</Link>
              </li>
              <li>
                <Link to="/article/best-superbuy-spreadsheet-shoes" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Shoes Guide</Link>
              </li>
              <li>
                <Link to="/article/best-superbuy-spreadsheet-hoodies" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Hoodies Guide</Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">FAQ</a>
              </li>
              <li>
                <a href="#categories" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">All Categories</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-white/50 mb-5">
              Legal & Safety
            </h4>
            <div className="w-8 h-px bg-white/20 mb-5"></div>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Privacy Policy</a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Terms of Use</a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Disclaimer</a>
              </li>
              <li>
                <a href="#" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Safety Guidelines</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-white/50 mb-5">
              Connect
            </h4>
            <div className="w-8 h-px bg-white/20 mb-5"></div>
            <ul className="space-y-3">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Main Website</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Superbuy Sheet</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/65 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Buy It Now</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-8 pt-10 border-t border-white/10">
          <div>
            <div className="flex items-baseline gap-3 mb-2">
              <span className="font-heading text-4xl md:text-5xl font-bold tracking-tight">SUPERBUY</span>
              <span className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-accent-400">SHEET</span>
            </div>
            <div className="w-12 h-px bg-white/20 mb-3"></div>
            <p className="text-xs text-white/35 max-w-[300px] leading-relaxed">
              The most complete curated shopping spreadsheet resource. Helping thousands discover better products every day.
            </p>
          </div>

          <div className="flex flex-col items-start sm:items-end gap-3">
            <div className="flex items-center gap-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-white/80 transition-colors cursor-pointer" aria-label="Social media">
                <i className="ri-twitter-x-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-white/80 transition-colors cursor-pointer" aria-label="Social media">
                <i className="ri-instagram-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-white/80 transition-colors cursor-pointer" aria-label="Social media">
                <i className="ri-pinterest-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-white/80 transition-colors cursor-pointer" aria-label="Social media">
                <i className="ri-reddit-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
            <p className="text-xs text-white/30">
              &copy; 2026 Superbuy Spreadsheet. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}